import { render, staticRenderFns } from "./AssessmentComplete.vue?vue&type=template&id=72af694d"
import script from "./AssessmentComplete.vue?vue&type=script&lang=ts"
export * from "./AssessmentComplete.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentComplete.vue?vue&type=style&index=0&id=72af694d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports